import React from 'react';
import { marked } from 'marked';
import clsx from 'clsx';

interface MarkdownContentProps {
    content: string;
    className?: string;
    style?: React.CSSProperties;
}

// Renders a ShowSetting value saved by the Toast UI markdown editor (Legacy TSE.Web.UI).
// Values are markdown that may contain inline HTML (e.g. the colorSyntax plugin's
// <span style="color:...">), but can also be plain HTML saved by the old rich-text
// editors — raw HTML passes through the markdown parser unchanged, matching the
// legacy Toast UI viewer behavior.
export const MarkdownContent: React.FC<MarkdownContentProps> = ({ content, className, style }) => {

    const container = React.useRef<HTMLDivElement>(null);

    const html = marked.parse(content || '', { async: false });

    // The editor saves links as plain markdown ([text](url)); open them in a new tab
    // so following an attachment or external link never navigates away from the SPA.
    React.useEffect(() => {
        container.current?.querySelectorAll('a').forEach(anchor => {
            anchor.target = '_blank';
            anchor.rel = 'noopener noreferrer';
        });
    }, [html]);

    return (
        <div ref={container} className={clsx('markdown-content', className)} style={style} dangerouslySetInnerHTML={{ __html: html }}>
        </div>
    );
};
